import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PageTitle = styled(Box)(
  ({ theme }) => `
    padding: ${theme.spacing(1, 0)};
`
);
